var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 305,
    height: 138,
    viewBox: "0 0 305 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.247 10.43l9.634-1.978L68.968 0l4.867 8.585 9.578 2.243-6.632 7.28.839 9.845-8.96-4.088-9.072 3.845 1.093-9.811-6.434-7.47zM244.095 18.84l5.082 1.943 4.888-2.428-.285 5.45 3.799 3.896-5.26 1.422-2.539 4.84-2.962-4.57-5.375-.906 3.43-4.25-.778-5.397zM.19 138c-2.234-25.664 15.616-43.98 34.327-43.98 4.601-34.374 40.756-64.17 84.882-50.479 9.908-21.59 28.164-36.084 49.15-36.084 23.327 0 43.377 17.992 52.193 43.68 3.901-1.798 8.036-2.798 12.405-2.798 10.688 0 20.362 5.897 26.994 15.393 2.73-.8 5.617-1.3 8.503-1.3 20.051 0 36.356 20.892 36.356 46.581 0 10.895-2.965 20.99-7.88 28.887H.19v.1z",
    fill: "#BFD3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M269.432 114.732l6.354.528c2.117 0 3.706-1.057 4.235-3.173l6.883-61.343c0-2.115-1.059-3.701-3.177-4.23l-6.353-.53c-2.118 0-3.706 1.059-4.236 3.174l-6.882 61.343c-.53 2.115 1.059 3.702 3.176 4.231z",
    fill: "#FFE2BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M262.02 56.034h2.118c.529 0 1.588.529 1.588 1.586v3.702h-4.764V57.62c0-1.057.529-1.586 1.058-1.586z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M259.9 59.736h6.354v58.699H259.9V59.736z",
    fill: "#7BD3E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M251.18 53.596l5.23-.82 9.109 57.989-5.23.82-9.109-57.989z",
    fill: "#8A76FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M252.489 50.215h1.588c.53 0 1.059 0 1.059.529l.53 3.173c0 .529 0 1.057-.53 1.057h-1.588c-.529 0-1.059 0-1.059-.528l-.529-3.173c-.529-.53 0-1.058.529-1.058z",
    fill: "#8A76FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M250.37 69.78c0-1.058-2.646-15.336-2.646-15.336 0-.529 0-1.058.529-1.058h1.059s2.117 14.807 2.646 15.865c0 2.115-1.588 2.115-1.588.529z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M248.65 53.537l7.848-1.216.244 1.568-7.849 1.217-.243-1.569zM252.489 138h30.708l5.294-52.353h-41.296L252.489 138z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M219.954 17.1H99.035c-2.382 0-4.17 2.09-4.17 4.477v78.487h128.961V21.577c.298-2.388-1.489-4.477-3.872-4.477z",
    fill: "#6D58B0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M216.9 96.066H101.824c-1.479 0-2.958-1.19-2.958-2.975V24.073c0-1.487 1.183-2.974 2.958-2.974H216.9c1.48 0 2.959 1.19 2.959 2.974v69.018c0 1.488-1.479 2.975-2.959 2.975z",
    fill: "#DDF0FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M176.857 117.521h-34.705v14.543h34.705v-14.543z",
    fill: "#9EB2EF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M186.645 138h-54.282a2.659 2.659 0 01-2.669-2.671v-.891a2.659 2.659 0 012.669-2.671h54.579a2.659 2.659 0 012.669 2.671v.891c-.296 1.484-1.483 2.671-2.966 2.671zM94.866 100.064v12.745c0 2.265 1.783 4.248 4.16 4.248h120.671c2.378 0 4.161-1.983 4.161-4.248v-12.745H94.866z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.256 105.352c0 3.265-1.78 7.124-5.636 7.124-3.857 0-5.637-3.562-5.637-7.124l3.56 1.781 2.077-3.561 1.779 3.264 3.857-1.484z",
    fill: "#9EB2EF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.88 110.962c-1.046-9.943-2.44-27.911-1.046-39.948 4.707 11.34 9.414 37.331 9.414 37.331 4.533-20.933 6.45-43.785 6.45-43.785 3.139 18.84 2.442 44.308 2.442 44.308 5.753-15.874 11.68-21.107 15.341-22.851C81.682 99.1 76.278 112.88 76.278 112.88l-20.398-1.919z",
    fill: "#008298"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M56.578 113.229s-11.681-35.935-25.28-44.657c16.911 1.57 29.464 32.97 29.464 32.97-2.267-14.479-1.395-47.623-1.395-47.623 7.148 15.7 8.891 46.75 8.891 46.75 4.359-8.547 9.938-36.807 10.112-37.679 5.753 16.223-3.487 50.065-3.487 50.065H56.578v.174z",
    fill: "#02AFBC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M75.058 138H55.88l-3.66-21.98 26.325-.174L75.058 138z",
    fill: "#7DA9FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78.022 119.509H52.917l-.698-3.314h26.326l-.523 3.314z",
    fill: "#618FDB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M77.499 116.369H53.265a2.754 2.754 0 01-2.789-2.791v-.872c0-1.57 1.22-2.791 2.79-2.791h24.233c1.569 0 2.789 1.221 2.789 2.791v.872c0 1.57-1.22 2.791-2.79 2.791z",
    fill: "#7DA9FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 105.725,
    y: 30.312,
    width: 26.659,
    height: 8.166,
    rx: 4.083,
    fill: "#CCDCFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 137.698,
    y: 30.312,
    width: 77.04,
    height: 8.166,
    rx: 4.083,
    fill: "#CCDCFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 105.725,
    y: 46.478,
    width: 26.659,
    height: 8.166,
    rx: 4.083,
    fill: "#CCDCFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 137.698,
    y: 46.478,
    width: 77.04,
    height: 8.166,
    rx: 4.083,
    fill: "#CCDCFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 105.725,
    y: 62.644,
    width: 26.659,
    height: 8.166,
    rx: 4.083,
    fill: "#CCDCFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 137.698,
    y: 62.644,
    width: 77.04,
    height: 8.166,
    rx: 4.083,
    fill: "#CCDCFF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 105.725,
    y: 78.81,
    width: 26.659,
    height: 8.166,
    rx: 4.083,
    fill: "#CCDCFF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 137.698,
    y: 78.81,
    width: 77.04,
    height: 8.166,
    rx: 4.083,
    fill: "#CCDCFF"
  })));
}
export default SvgStub;